import { render, staticRenderFns } from "./PercentageInput.vue?vue&type=template&id=353c8a43"
import script from "./PercentageInput.vue?vue&type=script&lang=js"
export * from "./PercentageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports